import { render, staticRenderFns } from "./pdOffersList.vue?vue&type=template&id=e68db6b4"
import script from "./pdOffersList.vue?vue&type=script&lang=js"
export * from "./pdOffersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports